export default __webpack_public_path__ + "../staticImages/winefinder-sprite-taste-04-2x.png";